import { Branding, Link } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import CustomSelect, { CustomSelectItem } from 'components/custom-ui/CustomSelect';
import MobileStopPaymentView from "components/pages/StopPaymentHistoryPage/components/MobileStopPaymentView";
import { ContentHeaderView, FormContainer, FormRowView, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableView, WidgetContainer } from 'components/shared';
import { TableBody } from 'components/shared/views/TableView';
import { PrimaryButton } from 'components/ui';
import { Account, CheckingAccount, LOCAccount } from "model";
import React from "react";

export default function StopPaymentHistoryWidget(props) {
    const ui = props.ui ?? {};
    const data = props.data ?? {};
    const onChange = props.onChange ?? (() => {});
    const onClick = props.onClick ?? (() => {});
    const account = data.account ?? {};
    const payments = Util.inMabi ? (data.allStopPayments ?? []) : (data.payments ?? []);
    const accounts = data.accounts ?? [];
    
    const desktopItems = payments.map(payment => {
        return <StopPaymentItem payment={ payment } key={ `desktop_${ payment.id }`} />
    }, []);
    const mobileItems = payments.map(payment => {
        return <MobileStopPaymentView key={ `mobile_${ payment.id }`} payment={ payment } />
    }, []);

    return (
        <div className={ `flex-container flex-vertical flex-width` }>
        <WidgetContainer className="stop-payment-history-widget">
            <ContentHeaderView dataPoint="Stop_Payment_History_Header" text="Stop Payment History" />
            <Branding id="stoppayment_history_widget_abi22" value="false" default="false">
                <Link className="stop-payment-link" to="/stopPayment" dataPoint="Stop_Payment_History">Stop Payment</Link>
            </Branding>
            {/* Account Dropdown and Search button are not shown in mabi23. */}
            { !Util.inMabi && 
                <FormContainer className="stop-payments-history-form small-form-width">
                    <FormRowView text="Account:">
                        <AccountSelect isActive={ ui.accountSelect.isActive } value={ account } accounts={ accounts } onChange={ onChange("account") } dataPoint="Account_DD"/>
                    </FormRowView>
                    <FormRowView>
                        <PrimaryButton text="Search" onClick={onClick} data-point="Search"/>
                    </FormRowView>
                </FormContainer>
            }
            {/* All "Stop Payments" are shown by default in mabi23. */}
            { (ui.showPayments || Util.inMabi) && 
                <>
                {
                    desktopItems.length > 0 &&
                    <div className="show-on-desktop">
                        <TableView className="stop-payment-history-table">
                            <TableColumnContainer className="text-left">
                            <TableColumnView text="Start Check" icon="SortIcon"></TableColumnView>
                            <TableColumnView text="End Check" icon="SortIcon"></TableColumnView>
                            <TableColumnView text="Amount" icon="SortIcon"></TableColumnView>
                            <TableColumnView text="Effective" icon="SortIcon"></TableColumnView>
                            <TableColumnView text="Payee"></TableColumnView>
                            <TableColumnView text="Reason"></TableColumnView>
                            <TableColumnView text="CheckDate"></TableColumnView>
                            </TableColumnContainer>

                            <TableBody>
                                { desktopItems }
                            </TableBody>
                        </TableView>
                    </div>
                }

                { mobileItems }
                </>
            }
        </WidgetContainer>
        </div>
    )
}

export function AccountSelect(props){
    const isActive = props.isActive ?? undefined;
    const accounts = Account.hasLOCAccounts() ? LOCAccount.initAll() : CheckingAccount.initAll();
    const value = props.value === undefined || props.value === "" ? accounts[0] : props.value;

    let accountItems = accounts.map(function(account){
        return  <CustomSelectItem value={account} key={account.id} data-point={`Checking_Account_${account.id}`}>
                    <p>{account.number} - {account.nickname} (Available {account.availableBalance ? account.availableBalance.format() : account.availableCredit.format() })</p>
                </CustomSelectItem>
    });

    const dataPoint = props.dataPoint ?? "";

    return(
        <CustomSelect active={ isActive } value={ value } data-point={dataPoint} onChange={ props.onChange }>
            {accountItems}
        </CustomSelect>
    )
}

/**
 * @function function StopPaymentItem(props){

 * @param {STRING} payment - Brings in the payment details  
 * @return {React.Component}
 * @exported true
 * @description The StopPaymentItem shows the payment details
 * @example
 * <StopPaymentItem payment={payment} />
 */

function StopPaymentItem(props){
    let payment = props.payment; 
    return(
      <TableItemContainer>
        <TableItemTextView text={payment.startCheck} dataPoint={`Start_Check_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.endCheck} dataPoint={`End_Check_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.amount.format()} dataPoint={`Amount_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.effective.format("m/d/Y")} dataPoint={`Effective_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.payee} dataPoint={`Payee_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.reason} dataPoint={`Reason_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.checkDate.format("m/d/Y")+" "+ payment.checkTime} dataPoint={`CheckDate_${payment.id}`}></TableItemTextView>
      </TableItemContainer>
    )
  } 
